import * as yup from 'yup'
import { IntlShape, defineMessages } from 'react-intl'
import { IVehicleDetailsFormValues } from 'features/Vehicles/types'

const companyMessages = defineMessages({
  min: {
    id: 'vehiclesV2.vehicleDetailsForm.company.min',
    defaultMessage: 'At least one company is required'
  }
})

const nameMessages = defineMessages({
  required: {
    id: 'vehiclesV2.vehicleDetailsForm.name.required',
    defaultMessage: 'Name is required'
  },
  max: {
    id: 'vehiclesV2.vehicleDetailsForm.name.max',
    defaultMessage: 'Name cannot be longer than {max} characters'
  }
})

const vinMessages = defineMessages({
  required: {
    id: 'vehiclesV2.vehicleDetailsForm.vin.required',
    defaultMessage: 'VIN is required'
  },
  max: {
    id: 'vehiclesV2.vehicleDetailsForm.vin.max',
    defaultMessage: 'VIN cannot be longer than {max} characters'
  }
})

const cityNameMessages = defineMessages({
  max: {
    id: 'vehiclesV2.vehicleDetailsForm.cityName.max',
    defaultMessage: 'City name cannot be longer than {max} characters'
  }
})

export const schema = (intl: IntlShape): yup.SchemaOf<IVehicleDetailsFormValues> => {
  const validations = {
    companies: (yup.array() as yup.SchemaOf<IVehicleDetailsFormValues['companies']>).min(
      1,
      intl.formatMessage(companyMessages.min)
    ),
    name: yup
      .string()
      .max(128, ({ max }) => intl.formatMessage(nameMessages.max, { max }))
      .required(intl.formatMessage(nameMessages.required)),
    vin: yup
      .string()
      .max(128, ({ max }) => intl.formatMessage(vinMessages.max, { max }))
      .required(intl.formatMessage(vinMessages.required)),
    cityName: yup.string().max(255, ({ max }) => intl.formatMessage(cityNameMessages.max, { max })),
    state: yup
      .object()
      .shape({
        name: yup.string().required(),
        code: yup.string().required()
      })
      .nullable()
  }

  return yup.object().shape(validations)
}
